function SplitTheText() {
	this.scenes = [];
	this.build();
	barbaCallbacks.push(this);
	resizeCallbacks.push(this);
}

SplitTheText.prototype.build = function () {
	let that = this;
	$('.split-text').each(function () {
		let element = jQuery(this);

		if (element.hasClass('is-revealed'))
			return;

		if (element.is('.split--word')) {
			that.scenes.push(new SplitText(element.find('span'), {
				type: 'words',
				wordsClass: 'split-word'
			}));
		} else if (element.is('.split--line')) {
			that.scenes.push(
				new SplitText(element, {
					type: 'lines',
					linesClass: 'split-line'
				})
			);
		}
	});
};

SplitTheText.prototype.resize = function () {
	this.scenes.forEach(function (elem){
		elem.revert();
	});
	this.build();
};
